import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Loader2, MailCheck } from 'lucide-react';
import { AuthShell } from '../components/auth/AuthShell';
import { formatApiError } from '../lib/errors';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell testId="forgot-password-page" title="Reset your password"
      description="Enter the email you sign in with and we'll send you a reset link.">
      {sent ? (
        <div className="space-y-4 text-center" data-testid="forgot-password-sent">
          <MailCheck className="w-10 h-10 text-emerald-400 mx-auto" />
          <p className="text-slate-300 text-sm">
            If an account exists for <span className="text-white font-medium">{email}</span>, a reset link is on its way. It expires in 1 hour.
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email" className="text-slate-300">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="bg-slate-800/50 border-slate-700 text-white" data-testid="forgot-email-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-blue-500 hover:bg-blue-600 text-white h-11"
            data-testid="forgot-submit-btn">
            {loading && <Loader2 className="w-4 h-4 animate-spin mr-2" />}Send reset link
          </Button>
        </form>
      )}
      <p className="mt-6 text-center text-sm text-slate-400">
        <Link to="/login" className="text-blue-400 hover:text-blue-300" data-testid="forgot-back-to-login">Back to sign in</Link>
      </p>
    </AuthShell>
  );
}
